import {
  Box, InputLabel, Switch, Typography, FormHelperText,
} from '@mui/material';
import { InputProps, useInput, useTranslate } from 'react-admin';

type Props = InputProps & {
  isRequired?: boolean;
  helperText?: string | false;
};

export const GrayBooleanSwitchWithUpperLabel = (props: Props) => {

  const translate = useTranslate();
  const { id, field } = useInput({
    source: props.source,
    defaultValue: props.defaultValue ?? false,
    disabled: props.disabled,
  });

  const checked = Boolean(field.value);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 2,
        width: '100%',
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <InputLabel className="input-label" required={props.isRequired} htmlFor={id}>
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
        {props.helperText && (
          <FormHelperText className="input-helper-under-label" sx={{ mt: 0, mb: 0, ml: 0 }}>
            {translate(props.helperText)}
          </FormHelperText>
        )}
      </Box>

      <Box sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        flexShrink: 0,
      }}>
        <Switch
          id={id}
          name={field.name}
          checked={checked}
          onChange={(event) => {

            field.onChange(event.target.checked);
            field.onBlur();

          }}
          disabled={props.disabled}
          inputRef={field.ref}
          color="primary"
        />
        <Typography component="span" sx={{ color: 'text.primary' }}>
          {translate(checked ? 'general.text.yes' : 'general.text.no')}
        </Typography>
      </Box>
    </Box>
  );

};
